import script from "./AppKintzBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./AppKintzBanner.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__